<div class="notification-center">

  <div class="notification-icon-container" (click)="showNotificationCenterClick()">
    @if (notifyCount > 0) {
      <div class="notifications-circle overlay">{{this.notifyCount}}</div>
    }
    <div class="notification-inner">
      <i class="far fa-bell"></i>
    </div>
  </div>

</div>

<div class="dropdown-notification-center" [class.show]="showNotification">
  <div class="dropdow-title">Notifications <i class="far fa-times" (click)="showNotificationCenterClick()"></i></div>

  <!-- this has to be converted to an AND statement for each notification type -->
  @if (allNotifications.length === 0) {
    <div class="noNotifications">
      @if (!pageLoading) {
        <span class="all-caught-up">
          <i class="fal fa-thumbs-up"></i><br>
          All caught up!
        </span>
      }
      @if (pageLoading) {
        <span class="loader"></span>
      }
    </div>
  }
  <!-- When we have multiple types, we just need to build a section per type and iterate through -->
  <!-- So notifications, for examples, becomes downloadNotifications, analysisNotifications, etc. -->
  @if (downloadNotifications.length > 0) {
    <ul class="notifyList">
      <li>
        <div class="sectionHeader">
          <span class="notifyType">Downloads</span>
          <span class="markRead">
            <i class="far fa-check-circle" pTooltip="Mark all as read" tooltipPosition="left" (click)="markAllAsRead(1);"></i>
          </span>
          <span class="markDeleted"><i pTooltip="Delete all" tooltipPosition="left" class="fa fa-trash" (click)="deleteAll(1);"></i></span>
        </div>
      </li>
      @for (item of downloadNotifications; track item; let i = $index) {
        <li [class.read]='item.isRead'>
          <div class="details">
            <div class="detail-status-icons" (click)='redirect(item)'>
              @if (item.processStatusID === 30) {
                <i class="far fa-download" [attr.data-test-id]="item.redirectURL" [attr.data-test-data]="cypressDownloadAttr"></i>
              }
              @if (item.processStatusID === 20) {
                <i class="fal fa-spinner-third fa-spin"></i>
              }
              @if (item.processStatusID === 10) {
                <i class="fal fa-spinner-third fa-spin"></i>
              }
              @if (item.processStatusID === -1) {
                <i class="far fa-exclamation-circle"></i>
              }
            </div>
            <div class="detail-dl-name" (click)='redirect(item)'>
              {{item.details}}
              <div class="ago">{{item.timeSince}}</div>
            </div>
            <div class="notifyHeader">
              <!--<span class="notifyType">{{item.displayName}}</span>-->
              <span class="markRead">
                @if (!item.isRead) {
                  <i class="far fa-check-circle" title="Mark as read" (click)="markAsRead(item);"></i>
                }
              </span>
              <span class="markDeleted">
                <i title="Delete" class="fa fa-trash" (click)="deleteItem(item);"></i>
              </span>
            </div>
          </div>
        </li>
      }
    </ul>
  }
</div>
